export const REACT_FLOW_DRAG_CLASS_NAME = 'chamn-action-drag-handler';

export const INPUT_HANDLE_ID = 'INPUT_HANDLE_ID';

export const OUTPUT_HANDLE_ID = 'OUTPUT_HANDLE_ID';

export const REQUEST_API_FAILED_HANDLE_ID = 'REQUEST_API_FAILED_HANDLE_ID';
